import '@/lib/unpoly';
import { Application } from '@hotwired/stimulus';
import CheckboxController from '@/controllers/checkbox_controller';

const application = Application.start();
application.register('checkbox', CheckboxController);
